var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m2.854-7.146a.5.5 0 1 0-.708-.708L4.75 7.543 3.354 6.146a.5.5 0 1 0-.708.708L4.043 8.25a1 1 0 0 0 1.414 0z",
    clipRule: "evenodd"
  })));
});
const SvgCheckCircleFilledsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircleFilledsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDEyQzkuMzEzNzEgMTIgMTIgOS4zMTM3MSAxMiA2QzEyIDIuNjg2MjkgOS4zMTM3MSAwIDYgMEMyLjY4NjI5IDAgMCAyLjY4NjI5IDAgNkMwIDkuMzEzNzEgMi42ODYyOSAxMiA2IDEyWk04Ljg1MzU1IDQuODUzNTVDOS4wNDg4MiA0LjY1ODI5IDkuMDQ4ODIgNC4zNDE3MSA4Ljg1MzU1IDQuMTQ2NDVDOC42NTgyOSAzLjk1MTE4IDguMzQxNzEgMy45NTExOCA4LjE0NjQ1IDQuMTQ2NDVMNC43NSA3LjU0Mjg5TDMuMzUzNTUgNi4xNDY0NUMzLjE1ODI5IDUuOTUxMTggMi44NDE3MSA1Ljk1MTE4IDIuNjQ2NDUgNi4xNDY0NUMyLjQ1MTE4IDYuMzQxNzEgMi40NTExOCA2LjY1ODI5IDIuNjQ2NDUgNi44NTM1NUw0LjA0Mjg5IDguMjVDNC40MzM0MiA4LjY0MDUzIDUuMDY2NTggOC42NDA1MiA1LjQ1NzExIDguMjVMOC44NTM1NSA0Ljg1MzU1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";